import { render, staticRenderFns } from "./RightFunPop.vue?vue&type=template&id=71dc208a&scoped=true"
import script from "./RightFunPop.vue?vue&type=script&lang=js"
export * from "./RightFunPop.vue?vue&type=script&lang=js"
import style0 from "./RightFunPop.vue?vue&type=style&index=0&id=71dc208a&prod&lang=scss&scoped=true"
import style1 from "./RightFunPop.vue?vue&type=style&index=1&id=71dc208a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc208a",
  null
  
)

export default component.exports